import moment from 'moment';
import Constants from './Constants.js';
export default {
	format: function(value) {
		if (!value) {
			return 'N/D';
		}
		return moment(parseInt(value)).utcOffset(-240).format(Constants.DATE_FORMAT);
	},
	getTimestampFromDate(date) {
		return moment(date).toDate().getTime();
	}
};
